const t = `.delivery-method[data-v-6a939f42]{display:flex!important;align-items:center!important}
`;
export {
  t as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/delivery-method/components/deliveryMethodSelect.ce.vue3.js
// module id = 1233
// module chunks = 41